export { isArrayOfStrings };
import { isArray } from './isArray.js';
function isArrayOfStrings(val) {
    return isArray(val) && val.every((v) => typeof v === 'string');
}
